import login from'./view/login'
import router from'./view/router'
import base from'./view/base/index.js'
import sportExercise from './view/sportExercise/index.js'
import sportTest from './view/sportTest/index.js'
import sportsGame from './view/sportsGame/index.js'
import sportEvaluation from './view/sportEvaluation/index.js'
import sportsTeach from'./view/sportsTeach/index.js'
import hm from'./view/hm/index.js'
import resources from'./view/resources/index.js'
import statisticsReport from './view/statisticsReport/index.js'

export default {
    router,
    views:{
        login,
        sportExercise,
        sportTest,
        sportsGame,
        base,
        sportEvaluation,
        sportsTeach,
        hm,
        resources,
        statisticsReport
    },
    inputRequired:{
        '请填写登录用户名':'請填寫登錄用戶名',
        '请填写登录密码':'請填寫登錄密碼',
        '登录密码格式仅支持大小写字母、数字及特殊符号':'登錄密碼格式僅支持大小寫字母、數字及特殊符號',
        '请填写验证码':'請填寫驗證碼',
    },
    inputPlaceholder:{
        '请输入用户名（账号 或 手机号）':'請輸入用戶名（賬號 或 手機號）',
        '请输入密码':'請輸入密碼',
        '请输入验证码':'請輸入驗證碼',
        '名称/编码模糊搜索':'名稱/編碼模糊搜索',
    },
    from:{
        '全部':'全部',
        '类型':'類型',
        '状态':'狀態',
        '请选择状态':'請選擇狀態',
        '性质':'性質',
        '搜索':'搜索',
        '重置':'重置',
        '查询':'查詢',
        '新增':'新增',
        '启用':'啟用',
        '停用':'停用',
        '查看':'查看',
        '数据':'數據',
        '编辑':'編輯',
        '删除':'刪除',
        '保存':'保存',
        '操作':'操作',
        '下载':'下載',
        '备注':'備註',
        '返回':'返回',
        '其他':'其他',
        '租户':'租戶',
        '机构':'機構',
        '请选择机构':'請選擇機構',
        '联系方式':'聯繫方式',
        '邮箱':'郵箱',
        '创建人':'創建人',
        '创建时间':'創建時間',
        '更新时间':'更新時間',
        '基本信息':'基本信息',
        '区域':'區域',
        '详细地址':'詳細地址',
        '扩展信息':'擴展信息',
        '机构LOGO':'機構LOGO',
        '平台LOGO':'平台LOGO',
        '域名':'域名',
        '通用':'通用',
        '项目':'項目',
        '项目名称':'項目名稱',
        '项目ID':'項目ID',
        '项目状态':'項目狀態',
        '知道了':'知道了',
        '页':'頁',
        '条':'條',
        '共计{total}条数据':'共計{total}條數據',
        '取消':'取消',
        '下一步':'下一步',
        '上一步':'上一步',
        '确认':'確認',
        '确定':'確定',
        '保存成功！':'保存成功！',
        '发布范围':'發佈範圍',
        '请输入{name}':'請輸入{name}',
        '请选择{name}':'請選擇{name}',
        '分':'分',
        '秒':'秒',
        '个':'個',
        '次':'次',
        '已启用':'已啟用',
        '已停用':'已停用',
        '启用':'啟用',
        '停用':'停用',
        '成功':'成功',
        '失败':'失敗',
        '男':'男',
        '女':'女',
        '等级':'等級',
        '暂无':'暫無',
        '结束':'結束',
        '重置密码':'重置密碼',
        '批量移除':'批量移除',
        '批量新增':'批量新增',
        '移除':'移除',
        '全部选择':'全部選擇',
        '平台':'平台',
        '点击查看大图':'點擊查看大圖',
        '排序':'排序',
        '发布':'發佈',
        '序号':'序號',
        '上移':'上移',
        '下移':'下移',
        '学级':'學級',
        '请选择学级':'請選擇學級',
        '年级':'年級',
        "院系":'院系',
        "专业":'專業',
        "请选择专业":'請選擇專業',
        '班级':'班級',
        '应用终端':'應用終端',
        '请选择应用终端':'請選擇應用終端',
        '场景':'場景',
        '请选择项目':'請選擇項目',
        '运动时间':'運動時間',
        '运动时长':'運動時長',
        '姓名、学籍号模糊搜索':'姓名、學籍號模糊搜索',
        '姓名模糊搜索':'姓名模糊搜索',
        '视频回看':'視頻回看',
        '视频预览':'視頻預覽',
        '所属机构':'所屬機構',
        '性别':'性別',
        '学籍号':'學籍號',
        '锻炼时长':'鍛煉時長',
        '测试时间':'測試時間',
        '成绩':'成績',
        '出手':'出手',
        '出手次数':'出手次數',
        '命中':'命中',
        '对手':'對手',
        '胜负':'勝負',
        '比分':'比分',
        '胜利':'勝利',
        '平手':'平手',
        '运动时间':'運動時間',
        '学年':'學年',
        '请选择学年':'請選擇學年',
        '（当前学年）':'（當前學年）',
        '学期':'學期',
        '请选择学期':'請選擇學期',
        '（当前学期）':'（當前學期）',
        '秒':'秒',
        '批量导出':'批量導出',
        '姓名':'姓名',
        '得分':'得分',
        '分数':'分數',
        '管理':'管理',
        '批量操作':'批量操作',
        '批量导入':'批量導入',
        '标准分':'標準分',
        '附加分':'附加分',
        '用户名称':'用戶名稱',
        '评分标准':'評分標準',
        '违规':'違規',
        '照片':'照片',
        '已上传':'已上傳',
        '未上传':'未上傳',
        '姓名、准考证号模糊搜索':'姓名、准考證號模糊搜索',
        '准考证号':'准考證號',
        '报考项目':'報考項目',
        '用户名搜索':'用戶名搜索',
        '全选（跨页）':'全選（跨頁）',
        '学校':'學校',
        '教师':'教師',
        '手机号':'手機號',
        '账号':'賬號',
        '用户':'用戶',
        '关闭':'關閉',
        '更多':'更多',
        '上传':'上傳',
        '所属项目':'所屬項目',
        '清空':'清空',
        '视频':'視頻',
        '修改':'修改',
        '不限':'不限',
        '认证':'認證',
        '运动报告':'運動報告',

        '详情':'詳情',
        //25-8-1
        '操作成功':'操作成功',
        '场所':'場所',
        //25-12-19
        '民族':'民族',
        //26-1-7
        '有效':'有效',
        '自由锻炼':'自由鍛煉',
        '微球场':'微球場',
        '应用终端':'應用終端',
        '竞技场':'競技場',
        '趣味锻炼':'趣味鍛煉',
        '是':'是',
        '否':'否',
        '时长':'時長',
        //26-6-16
        '运动结果':'運動結果',
        '达标状态':'達標狀態',
        '已达标':'已達標',
        '未达标':'未達標',
        //26-7-7 阳光跑统计报表
        '时间':'時間',
        '日期':'日期',
        '周':'週',
        '月':'月',
        '自定义':'自定義',
        '总里程':'總里程',
        '平均配速':'平均配速',
        '人':'人',
        '参与率':'參與率',
        '导出报表':'導出報表',
        '请选择年级':'請選擇年級',
    },
    udload:{
        '1、下载导入模版、填写信息':'1、下載導入模版、填寫信息',
        '2、上传填写好的文件，导入数据':'2、上傳填寫好的文件，導入數據',
        '下载模板':'下載模板',
        '选择文件':'選擇文件',
        '导入':'導入',
        '导出':'導出',
        '导出失败':'導出失敗',
        '数据导入中':'數據導入中...',
        '下载失败记录':'下載失敗記錄',
        '重新上传':'重新上傳',
        '导入完成':'導入完成',
        '导入成功！':'導入成功！',
        '导入失败！':'導入失敗！',
        '数据导入成功！':'數據導入成功！',
        '数据导入失败！':'數據導入失敗！',
        '失败记录':'失敗記錄',
        '只能导入Excel表格文件！':'只能導入Excel表格文件！',
        '文件上传成功！':'文件上傳成功！',
        '文件格式不正确，请重新上传！':'文件格式不正確，請重新上傳！',
        '上传中...':'上傳中...',
        '上传中':'上傳中...',
        '点击上传':'點擊上傳',
        '请上传文件':'請上傳文件',
        '下载模版':'下載模版',
        '上传图片': '上傳圖片',
        '成绩导入完成':'成績導入完成',
        '批量成绩导入失败列表':'批量成績導入失敗列表',
        '姓名,学籍号,失败原因':'姓名,學籍號,失敗原因',
        '文件':'文件',
        '请选择运动员':'請選擇運動員',
        '文件大小不符合规范！':'文件大小不符合規範！',
        '文件分辨率或大小超出范围！': '文件分辨率或大小超出範圍！', 
        '文件上传中':'文件上傳中',
        '文件上传完成':'文件上傳完成',
        '后台数据处理中，成绩导入完成预计3到5分钟（可关闭窗口，不影响导入）':'後台數據處理中，成績導入完成預計3到5分鐘（可關閉窗口，不影響導入）',
        '支持上传PNG、JPG格式图片，且图片小于5M':'支援上傳 PNG、JPG 格式圖片，且圖片檔案小於 5MB',
        '支持上传mp4格式，且视频小于2G':'支援上傳 MP4 格式影片，且影片檔案小於 2GB',
        '支持上传MP3格式，且音频小于20M':'支援上傳 MP3 格式音訊，且音訊檔案小於 20MB',
        '成绩数据导入处理完成':'成績數據導入處理完成',
    },
    grd:{
        '一年级':'一年級',
        '二年级':'二年級',
        '三年级':'三年級',
        '四年级':'四年級',
        '五年级':'五年級',
        '六年级':'六年級',
        '初 一':'初 一',
        '初 二':'初 二',
        '初 三':'初 三',
        '高 一':'高 一',
        '高 二':'高 二',
        '高 三':'高 三',
        '大 一':'大 一',
        '大 二':'大 二',
        '大 三':'大 三',
        '大 四':'大 四',
    },
    message: {
        '是否返回': '是否返回',
        '是否返回上一页？': '是否返回上一頁？',
        '数据保存成功！': '數據保存成功！',
        '新增成功': '新增成功',
        '服务器出错，请稍后重试': '伺服器出錯，請稍後重試',
        '状态更改成功': '狀態更改成功',
        '修改成功': '修改成功',
        '删除成功': '刪除成功',
        '取消后，页面数据不再保存':'取消後，頁面數據不再保存',
        '操作成功': '操作成功',
        '返回后，页面数据不做保存': '返回後，頁面數據不做保存',
        '确认要返回吗？': '確認要返回嗎？',
        '请输入内容': '請輸入內容',
        '内容文本已超过限制字数': '內容文本已超過限制字數',
        '链接不存在，请重新插入': '鏈接不存在，請重新插入',
        '链接必须以': '鏈接必須以 http/https 開頭，請重新插入',
        '上传处理异常，请联系管理员': '上傳處理異常，請聯繫管理員',
        '图片预览': '圖片預覽',
        '音频预览': '音頻預覽',
        '上传图片': '上傳圖片',
        '文件大小不符合规范！': '文件大小不符合規範！',
        '上传文件格式错误！': '上傳文件格式錯誤！',
        '文件分辨率或大小超出范围！': '文件分辨率或大小超出範圍！',
        '上传成功！': '上傳成功！',

        '文件上传成功！': '文件上傳成功！',
        '文件格式不正确，请重新上传！': '文件格式不正確，請重新上傳！',
        '没有任何可用的角色权限信息，请联系管理员处理！':'沒有任何可用的角色權限信息，請聯係管理員處理！',
    }
};    
